import PropTypes from "prop-types";

export const TDefaultImgObj = {
	id: PropTypes.string,
	width: PropTypes.number,
	type: PropTypes.string,
};
export const TImgObj = {
	id: PropTypes.string,
	url: PropTypes.string,
	width: PropTypes.number,
	type: PropTypes.string,
};
